<div mat-dialog-content>
  @if (data.orderType == 'pickup') {
    <p style="text-align: center;">{{ 'Store.MoveDeliveryToPickup' | translate }}</p>
  }
  @if (data.orderType == 'delivery') {
    <p style="text-align: center;">{{ 'Store.MovePickupToDelivery' | translate }}</p>
  }
</div>
<div mat-dialog-actions style="justify-content: center;">
  <button mat-stroked-button style="margin-right: 8px;" [mat-dialog-close]="true">Yes</button>
  <button mat-stroked-button [mat-dialog-close]="false">No</button>
</div>